import moment from "moment/moment";
import {VALID_UNTIL_TODAY_VALUE} from "./constants";

export const NO_ORDER_TYPE_OPTION = {id: 'no_order', value: 'no order', label: 'Kein Orderzusatz'};

const getCurrentMonthOption = () => ({
  value: moment().endOf('month').format('YYYY-MM'),
  label: `Ultimo ${moment().format('MMMM')}`
})

export const getValidityDateOptions = () => {
  let orderValidityDates = [{value: VALID_UNTIL_TODAY_VALUE, label: 'tagesgültig'}, getCurrentMonthOption()];
  let futureMonth = moment().add(1, 'M');
  for (let m = 1; m < 12; m++) {
    orderValidityDates.push({
      value: moment(futureMonth).endOf('month').format('YYYY-MM'),
      label: `Ultimo ${futureMonth.format('MMMM')}`
    });
    futureMonth = moment(futureMonth).add(1, 'M');
  }

  return orderValidityDates;
}

export const initEinzeltitelSettings = (asset, stockExchangeOptions) => {
  if(!asset.order_type){
    asset.order_type_option = NO_ORDER_TYPE_OPTION;
    asset.order_type = asset.order_type_option.value;
  }
  if(!asset.valid_until){
    asset.valid_until_option = getCurrentMonthOption();
    asset.valid_until = asset.valid_until_option.value;
  }
  if(!asset.stock_exchange){
    asset.stock_exchange_option = stockExchangeOptions[0] || {};
    asset.stock_exchange = asset.stock_exchange_option.value;
  }
}